import 'styled-components';

const basePalette = {
    white_base: '#FFFFFF',
    white_0_tr_base: 'rgba(255, 255, 255, 0)',
    white_8_tr_base: 'rgba(255, 255, 255, 0.08)',
    white_24_tr_base: 'rgba(255, 255, 255, 0.24)',
    white_40_tr_base: 'rgba(255, 255, 255, 0.40)',
    white_64_tr_base: 'rgba(255, 255, 255, 0.64)',
    white_72_tr_base: 'rgba(255, 255, 255, 0.72)',
    black_48_tr_base: 'rgba(0, 0, 0, 0.48)',
    purple_0_tr_base: 'rgba(118, 51, 255, 0)',
    purple_100_base: '#7633FF',
    purple_8_lc_base: '#F4EFFF',
    purple_40_tr_base: 'rgba(118, 51, 255, 0.40)',
    super_light_base: '#F3F2F5',
};

const gradientsPalette = {
    aubergine_1: 'linear-gradient(180deg, #7633FF 0%, #974EF0 50%, #B163E3 100%)',
    aubergine_2: 'linear-gradient(180deg, #944BF0 0%, #AF60E0 50%, #C280EF 100%)',
    aubergine_3: 'linear-gradient(180deg, #B365E3 0%, #DAABFF 100%)',
    aubergine_4: 'linear-gradient(180deg, #7028E4 0%, #9F44FF 100%)',
    blue_1: 'linear-gradient(180deg, #7F2FFF 0%, #4E6AFF 100%)',
    blue_2: 'linear-gradient(180deg, #6250FF 0%, #4D69FF 50%, #588FF8 100%)',
    blue_3: 'linear-gradient(180deg, #4D69FF 0%, #68C4EE 100%)',
    passionFruit_1: 'linear-gradient(180deg, #A046FF 0%, #E482C9 100%)',
    passionFruit_2: 'linear-gradient(180deg, #C365E2 0%, #E482C9 50%, #EF8CA4 100%)',
    passionFruit_3: 'linear-gradient(180deg, #E482C9 0%, #FF9B6A 100%)',
    oceanBlue_1: 'linear-gradient(180deg, #7F2FFF 0.53%, #4D69FF 100%)',
};

// THEME PALETTE Light
const light = {
    ...basePalette,
    ...gradientsPalette,
    white: '#FFFFFF',
    black: '#141414',
    white_for_svg: 'ffffff',
    black_for_svg: '141414',
    white_72_tr: 'rgba(255, 255, 255, 0.72)',
    white_96_tr: 'rgba(255, 255, 255, 0.96)',
    grey_8_lc: '#F3F2F5',
    grey_8_lc_for_svg: 'F3F2F5',
    grey_16_lc: '#E4E4E5',
    grey_40_lc: '#9F9DA3',
    grey_40_lc_for_svg: '9F9DA3',
    grey_72_lc: '#77767A',
    grey_16_tr: 'rgba(100, 98, 104, 0.16)',
    grey_28_tr: 'rgba(159, 157, 163, 0.28)',
    purple_8_lc: '#F4EFFF',
    purple_16_lc: '#E9DEFF',
    purple_24_lc: '#DECEFF',
    purple_40_lc: '#C8ADFF',
    purple_72_lc: '#9C6CFF',
    purple_100: '#7633FF',
    purple_100_for_svg: '7633FF',
    purple_72_hc: '#5E29CC',
    purple_8_tr: 'rgba(118, 51, 255, 0.08)',
    purple_16_tr: 'rgba(118, 51, 255, 0.16)',
    purple_24_tr: 'rgba(118, 51, 255, 0.24)',
    purple_40_tr: 'rgba(118, 51, 255, 0.40)',
    purple_72_tr: 'rgba(118, 51, 255, 0.72)',
    pink_8_lc: '#FFF0F4',
    pink_16_lc: '#FFE2E9',
    pink_40_lc: '#FFB5C9',
    pink_72_lc: '#FF7B9E',
    pink_100: '#FF4778',
    pink_8_tr: 'rgba(255, 71, 120, 0.08)',
    pink_16_tr: 'rgba(255, 71, 120, 0.16)',
    pink_40_tr: 'rgba(255, 71, 120, 0.40)',
    pink_72_tr: 'rgba(255, 71, 120, 0.72)',
    shadow_purple: '0px 8px 8px 0px rgba(118, 51, 255, 0.16)',
    shadow_grey: '0px 8px 8px 0px rgba(20, 20, 20, 0.04), 0px 0px 8px 0px rgba(20, 20, 20, 0.04), 0px 0px 1px 0px rgba(20, 20, 20, 0.12)',
    shadow_search: '0 2px 12px 0 rgba(20, 20, 20, 0.06)',
    shadow_notification: '0 12px 24px 0 rgba(20, 20, 20, 0.06)',
    disabled_button_color: '#FFFFFF',
    black_88_lc: '#303030',
    black_80_lc: '#434343',
};

// THEME PALETTE Dark
const dark = {
    ...basePalette,
    ...gradientsPalette,
    white: '#141414',
    black: '#FFFFFF',
    white_for_svg: '141414',
    black_for_svg: 'ffffff',
    white_72_tr: 'rgba(0, 0, 0, 0.72)',
    white_96_tr: 'rgba(0, 0, 0, 0.96)',
    grey_8_lc: '#1E1F1F',
    grey_8_lc_for_svg: '1E1F1F',
    grey_16_lc: '#2A2C2C',
    grey_40_lc: '#4D4F4F',
    grey_40_lc_for_svg: '4D4F4F',
    grey_72_lc: '#888E90',
    grey_16_tr: 'rgba(153, 168, 168, 0.16)',
    grey_28_tr: 'rgba(55, 57, 57, 0.64)',
    purple_8_lc: '#1C1826',
    purple_16_lc: '#251B37',
    purple_24_lc: '#2D1F49',
    purple_40_lc: '#3E266C',
    purple_72_lc: '#5F35B2',
    purple_100: '#7C42F0',
    purple_100_for_svg: '7C42F0',
    purple_72_hc: '#A177F4',
    purple_8_tr: 'rgba(124, 66, 240, 0.08)',
    purple_16_tr: 'rgba(124, 66, 240, 0.16)',
    purple_24_tr: 'rgba(124, 66, 240, 0.24)',
    purple_40_tr: 'rgba(124, 66, 240, 0.40)',
    purple_72_tr: 'rgba(124, 66, 240, 0.72)',
    pink_8_lc: '#26191D',
    pink_16_lc: '#371E25',
    pink_40_lc: '#6C2E3F',
    pink_72_lc: '#B34361',
    pink_100: '#F1557F',
    pink_8_tr: 'rgba(241, 85, 127, 0.08)',
    pink_16_tr: 'rgba(241, 85, 127, 0.16)',
    pink_40_tr: 'rgba(241, 85, 127, 0.40)',
    pink_72_tr: 'rgba(241, 85, 127, 0.72)',
    shadow_purple: '0px 8px 8px 0px rgba(9, 7, 13, 0.32)',
    shadow_grey: '0px 8px 8px 0px rgba(0, 0, 0, 0.32), 0px 0px 8px 0px rgba(0, 0, 0, 0.32)',
    shadow_search: '0 2px 12px 0 rgba(0, 0, 0, 0.32)',
    shadow_notification: '0 12px 24px 0 rgba(0, 0, 0, 0.24)',
    disabled_button_color: 'rgba(255, 255, 255, 0.24)',
    black_88_lc: '#E4E4E5',
    black_80_lc: '#F3F2F5',
};
export default {
    light,
    dark,
};
